import React from "react";
import PropTypes from "prop-types";

import { MyDraggable as Draggable } from "../../components/Core";
import HoverBar from "../../components/HoverBar";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Container, Row, Col } from "reactstrap";
import { generateStyle, l, setOverLay } from "../../functions";
import Icon from "../../components/Icons";

import { connect } from "react-redux";
import isEqual from "lodash/isEqual";

const mapStateToProps = (state) => {
  return {
    currentLang: state.rootReducer.currentLang || 1,
    settings: state.rootReducer?.appearanceSettings || {},
  };
};

class ProductStockCountdown extends React.Component {
  constructor(props) {
    super(props);

    this.state = {};
  }

  shouldComponentUpdate(nextProp, nextState) {
    if (
      !isEqual(this.props?.payload, nextProp?.payload) ||
      !isEqual(this.props?.settings, nextProp?.settings)
    ) {
      return true;
    }

    return false;
  }

  _initTitle = () => {
    let { payload } = this.props;

    if (payload === null) payload = this.props.options.payload;

    let labelCountDown = "";

    if (payload.datas) {
      if (payload.datas["labelCountDown_" + this.props.currentLang])
        labelCountDown =
          payload.datas["labelCountDown_" + this.props.currentLang];
      else if (payload.datas["labelCountDown"])
        labelCountDown = payload.datas["labelCountDown"];
    }

    const { timerCountDown, counterColor, activeColor } = payload.datas || {
      timerCountDown: 60,
    };

    const cssSettings = generateStyle(payload, "container");
    const cssSettingsText = generateStyle(payload, "text", "body");

    return (
      <Container fluid={payload.fullContainer} style={cssSettings}>
        {setOverLay(payload)}
        <Row>
          <Col xs={12} className="fullcol">
            <div className="stock_countdown">
              {labelCountDown && (
                <h3 style={cssSettingsText}>
                  {labelCountDown.split("%%")[0]}
                  {labelCountDown.includes("%%") && (
                    <span
                      className="qty-available"
                      style={{ color: counterColor }}
                    >
                      {timerCountDown || 20}
                    </span>
                  )}
                  {labelCountDown.includes("%%")
                    ? labelCountDown.split("%%")[1]
                    : ""}
                </h3>
              )}
              <div className="progress-area">
                <div
                  className="progress-bar-success"
                  style={{ width: "70%", backgroundColor: activeColor }}
                ></div>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    );
  };

  render() {
    const {
      dropzoneID,
      parentID,
      showBasicContent,
      showPreview,
      id,
      dropzoneProps,
      payload,
      options,
      ...rest
    } = this.props;

    if (showBasicContent) {
      return (
        <Draggable {...this.props} side={true}>
          <span className="dragger">
            {(Array.isArray(rest.icon) && (
              <FontAwesomeIcon icon={rest.icon} />
            )) || <Icon icon={rest.icon} />}
            <span>{l(rest.name)}</span>
          </span>
        </Draggable>
      );
    }

    if (showPreview) {
      return <div>{this._initTitle()}</div>;
    }

    return (
      <Draggable {...this.props} minify={true}>
        <HoverBar
          datas={this.props}
          style={payload}
          parent={parentID}
          element={{ id, dropzoneID, parentID, payload }}
        />
        {this._initTitle()}
      </Draggable>
    );
  }
}

ProductStockCountdown.propTypes = {
  id: PropTypes.string.isRequired,
  showBasicContent: PropTypes.bool.isRequired,
};

export default connect(mapStateToProps)(ProductStockCountdown);
